import { request } from "../loaders/global";
import { logger } from "../logger";
import Stack from "../utils/Stack";

const pendingEvents = new Stack();

const cleanPendingEvents = async () => {
  while (!pendingEvents.isEmpty()) {
    let event = pendingEvents.pop();
    try {
      await traking(event, true);
    } catch (error) {
      pendingEvents.push(event);
    }
  }
};

const traking = async ({ eventName, eventAction }, loopPrevent = false) => {
  let connection_id = localStorage.getItem("connection_id");
  try {
    if (!connection_id) throw new Error("No connection_id found");
    await cleanPendingEvents();
    const data = {
      name: eventName,
      action: eventAction,
      page: location.pathname,
    };

    await request(
      `/api/strapi-tracking-plugin/connections/${connection_id}/events`,
      "post",
      data
    );
    logger.succes("EVENT SUCCES", "Sent event data with succes");
  } catch (error) {
    logger.error("EVENT ERROR", "Can't proceed the event tracking");

    if (!loopPrevent) pendingEvents.push({ eventName, eventAction });
  }
};

export const visitHandle = async (eventAction = "Nouvelle Visite") => {
  try {
    let date = localStorage.getItem("connection_created_at")
      ? new Date(localStorage.getItem("connection_created_at"))
      : null;
    let now = new Date();
    let diff = date ? Math.abs(now - date) : null;
    if (localStorage.getItem("connection_id") && diff < 1000 * 60 * 60 * 24)
      return traking({ eventName: "visit", eventAction });
    let { data } = await request(
      "/api/strapi-tracking-plugin/connections",
      "post",
      null,
      "res"
    );
    localStorage.setItem("connection_id", data.connection_id);
    localStorage.setItem("connection_created_at", data.connected_at);
    return traking({ eventName: "visit", eventAction });
  } catch (error) {
    logger.error("EVENT ERROR", "Can't proceed the visit handling");
  }
};

export default traking;
